/* eslint-disable camelcase */
import Media from 'components/contentBlocks/Media';
import PropTypes from 'prop-types';
import React from 'react';
import activeSetting from 'libs/wordpress/utils/activeSetting';
import colors from 'config/theme/colors';
import ratios from 'config/theme/ratios';
import transformFlexibleBackground from 'libs/wordpress/utils/transformFlexibleBackground';
import transformLink from 'libs/wordpress/utils/transformLink';
import useAboveBreakpoint from 'hooks/useAboveBreakpoint';

// Pure CMS data transformation before we send it to the "real" block!
const VideoInlineBlock = ({ content, isColumn = false, moduleTextColor = '' }) => {
    const { background_video: backgroundObj, link, settings } = content;

    // Transform link data
    let transformedLink;
    if (activeSetting(settings, 'link') && link) {
        transformedLink = transformLink(link);
    }

    // Transform video data
    const isAboveSm = useAboveBreakpoint('sm');
    const transformedBackground = transformFlexibleBackground(backgroundObj, 'video');
    const mobileBackground = transformedBackground.mobile;
    const desktopBackground = transformedBackground.desktop;

    // Transform color data
    const ligthTheme = moduleTextColor === 'white';
    const textColor = ligthTheme ? colors.white : colors.black;

    return (
        <Media
            background={isAboveSm ? desktopBackground : mobileBackground}
            backgroundRatio={
                isColumn
                    ? [ratios.vertical, ratios.square, ratios.verticalWide]
                    : [ratios.vertical, null, ratios.horizontal]
            }
            backgroundType="video"
            isColumn={isColumn}
            link={transformedLink}
            textColor={textColor}
        />
    );
};

VideoInlineBlock.propTypes = {
    content: PropTypes.shape({
        background_video: PropTypes.exact({
            desktop_background_video: PropTypes.object,
            mobile_background_video: PropTypes.object,
        }),
        link: PropTypes.object,
        settings: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
    isColumn: PropTypes.bool,
    moduleTextColor: PropTypes.string,
};

export default VideoInlineBlock;
